var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 11.2864V8.55102C12.667 6.59778 14.0003 3.99986 16.0003 2.66666C18.0003 3.99999 19.3336 6.59778 19.3336 8.55102V11.2864C19.3336 11.7322 19.5564 12.1485 19.9274 12.3958L20.7399 12.9375C21.1108 13.1848 21.3336 13.6011 21.3336 14.0469V16H10.6671L10.667 14.0469C10.667 13.6011 10.8898 13.1848 11.2607 12.9375L12.0732 12.3958C12.4442 12.1485 12.667 11.7322 12.667 11.2864Z",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0003 29.3333C27.8413 29.3333 29.3337 27.7415 29.3337 25.7777C29.3337 23.8141 27.8413 22.2223 26.0003 22.2223C26.0003 20.2585 24.5079 18.6667 22.667 18.6667",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 29.3333C4.15938 29.3333 2.66699 27.7415 2.66699 25.7777C2.66699 23.8141 4.15938 22.2223 6.00033 22.2223C6.00033 20.2585 7.49271 18.6667 9.33366 18.6667",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 19.3333V28",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 19.3333V24",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2);
export default __webpack_public_path__ + "static/media/p2.949b983a2f471db8a40c6e5cdbc506b6.svg";
export { ForwardRef as ReactComponent };